import React, { useState, useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { HeaderTrans, ProfileTrans } from '../../utils/translations';
import { useAppContext } from '../../context/AppContext';
import { useLocation, useNavigate } from "react-router-dom";
import { trackPixelEvent } from '../../utils/pixel';
import profilePlaceholder from "../../assets/profile.png";

/** Navbar "Войти": logged-in → schedule; not logged-in → Auth0 (post-login: library for landing/online club, schedule for individual) */
const PUBLIC_ENTRY_PATHS = ["/landing", "/onlineClub", "/individual"];

const LoginButton = ({ onLanding = false, onSelect }) => {
  const location = useLocation();
  const { language, user } = useAppContext();
  const { loginWithRedirect, logout } = useAuth0();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef(null);

  const isPublicEntryPage = PUBLIC_ENTRY_PATHS.includes(location.pathname);

  const logIn = () => {
    if (user && isPublicEntryPage) {
      navigate("/schedule");
      return;
    }
    if (location.pathname === "/landing" || location.pathname === "/onlineClub") {
      window.localStorage.setItem("redirectTo", "/library");
    } else if (location.pathname === "/individual") {
      window.localStorage.setItem("redirectTo", "/schedule");
    } else {
      window.localStorage.setItem("redirectTo", location.pathname);
    }
    loginWithRedirect({ ui_locales: navigator.language || "ru" });
  };

  const logOut = () => {
    const returnUrl = process.env.REACT_APP_FRONTEND_URL || window.location.origin;
    console.log("Logging out, returnTo:", returnUrl);
    logout({ returnTo: returnUrl });
    setShowUserMenu(false);
  };

  const goToProfile = () => {
    navigate("/profile");
    setShowUserMenu(false);
    onSelect?.();
  };

  const goToDashboard = () => {
    trackPixelEvent("NavigateToAdmin");
    navigate("/admin");
    setShowUserMenu(false);
    onSelect?.();
  };

  // Close the menu if clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowUserMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Landing navbar (onLanding) + online club: always show "Войти" so logged-in users can go to schedule
  const showLoginButton = !user || onLanding || location.pathname === "/onlineClub";
  return showLoginButton ? (
    <button className="hover:text-pink" onClick={logIn}>
      {HeaderTrans[language].login}
    </button>
  ) : (
    <div className="relative" ref={menuRef}>
      <img
        src={user?.picture || profilePlaceholder}
        alt="User profile"
        className="w-7 h-7 rounded-full cursor-pointer"
        onClick={() => setShowUserMenu(!showUserMenu)}
        onError={(e) => { e.currentTarget.src = profilePlaceholder }}
      />
      {showUserMenu && (
        <ul className="absolute -right-2 md:-right-8 mt-1 bg-white border rounded-lg shadow-lg w-fit z-20 cursor-pointer">
            {user?.role === 'admin' && (
              <li>
                <button
                  onClick={goToDashboard}
                  className="block w-full text-left px-4 py-2 rounded hover:bg-beige hover:text-white"
                >
                  {HeaderTrans[language].admin}
                </button>
              </li>
            )}
            <li>
              <button
                onClick={goToProfile}
                className="block w-full text-left px-4 py-2 rounded hover:bg-beige hover:text-white"
              >
                {ProfileTrans[language].profile}
              </button>
            </li>
            <li>
              <button
                onClick={logOut}
                className="block w-full text-left px-4 py-2 rounded hover:bg-beige hover:text-white"
              >
                {ProfileTrans[language].logout}
              </button>
            </li>
        </ul>
      )}
    </div>
  );
};

export default LoginButton;
